import React, { Component, useEffect, useState } from 'react'
import {
    Grid,
    Typography,
    Drawer,
    Toolbar,
    Divider,
    Box,
    Stack,
    CssBaseline,
    List,
    ListItem,
    Avatar
} from '@mui/material'
import * as Loaders from '../../components/UIComponents/Loader'
import * as Icons from '../../components/UIComponents/Icons'
import * as Buttons from '../../components/UIComponents/Button'
import * as IconButtons from '../../components/UIComponents/IconButtons'
import * as Texts from '../../components/UIComponents/Text'
import * as Images from '../../components/UIComponents/Images'
import Popover from '@mui/material/Popover'
import AlwaysScrollToBottom from '../../components/AlwaysScrollToBottom'
import TypingAnimation from '../../components/UIComponents/TypingAnimation'
import UrlContentPreview from './UrlContentPreview'
// import SourceInfoModal from './SourceInfoModal'
import moment from 'moment'
import { botImgObj } from '../ChatRoom'

const ChatWindow = ({
    messageArr
}) => {
    // console.log(messageArr)
    const [modalInfo, setModalInfo] = useState(null)
    const [openModal, setOpenModal] = useState(false)
    
    // if (!messageArr || messageArr.length <= 0) {
    //     return <Stack
    //         direction="column"
    //         justifyContent="flex-end"
    //         alignItems="flex-end"
    //         sx={{
    //             width: 1,
    //             px: 2,
    //             // bgcolor: 'secondary.main',
    //             pb: 3
    //         }}
    //     >
    //         <Box>
    //             <Images.ChatbotPointerRight
    //                 style={{
    //                     opacity: .8
    //                 }}
    //             />
    //         </Box>
    //         <Box>
    //             <Texts.Paragraph>
    //                 Have any questions? I am here to help.
    //             </Texts.Paragraph>
    //         </Box>
    //         <AlwaysScrollToBottom />
    //     </Stack>
    // }
    // console.log("received msg", messageArr)
    let renderMessage = []

    messageArr.forEach((m, i) => {
        if (m?.source === "user") {
            return renderMessage.push(<UserBubble
                key={`chat-bubble-${i}`}
                message={m?.message}
                time={m?.time}
            />)
        }
        // console.log(typeof m?.message)
        if (typeof m?.message === "object") {
            return renderMessage.push(<BotCarousel
                key={`chat-bubble-${i}`}
                message={m?.message}
                time={m?.time}
                image={typeof m?.image === "string" ? botImgObj[m?.image] : m?.image}
                typing={true}
            />)
        }
        return renderMessage.push(<BotBubble
            key={`chat-bubble-${i}`}
            message={m?.message}
            time={m?.time}
            image={typeof m?.image === "string" ? botImgObj[m?.image] : m?.image}
            typing={true}
            hasExtraInfo={m?.extraInfo}
            openModal={async () => {
                await setModalInfo(m?.extraInfo)
                await setOpenModal(true)
            }}
        />)
        // return setTimeout(() => {
        //     renderMessage.push(<BotBubble
        //         key={`chat-bubble-${i}-2`}
        //         message={m?.message}
        //         time={m?.time}
        //         image={m?.image}
        //         typing={false}
        //     />)
        //     console.log("to render",renderMessage)
        // }, 1500)
    })

    return <Stack
        direction="column"
        justifyContent="flex-end"
        alignItems="center"
        sx={{
            width: 1,
            px: 2,
            // bgcolor: 'secondary.main',
            pb: 3
        }}
    >
        {/*<SourceInfoModal 
            sourceDoc={modalInfo}
            active={openModal}
            onClose={() => {
                setOpenModal(false)
                setModalInfo(null)
            }}
        />*/}
        <Stack
            direction={"column"}
            spacing={0}
            sx={{
                p: 1,
                px: 2,
                m: 1,
                borderRadius: 2,
                bgcolor: 'secondary.light'
            }}
        >
            <Texts.SmallTip sx={{ lineHeight: 1.4 }} >伝え残した想いを、ここで話してみませんか？例えば…</Texts.SmallTip>
            <Texts.SmallTip sx={{ lineHeight: 1.4 }} >「ありがとうと言えなかったことはありますか？」</Texts.SmallTip>
            <Texts.SmallTip sx={{ lineHeight: 1.4 }} >「一番楽しかった思い出は何ですか？」</Texts.SmallTip>
            <Texts.SmallTip sx={{ lineHeight: 1.4 }} >「今のあなたに伝えたいことは？」</Texts.SmallTip>
            
        </Stack>
        {renderMessage}
        <AlwaysScrollToBottom />
    </Stack>


}

const BotCarousel = ({
    idx,
    message,
    timestamp,
    time,
    image,
    // typing = false,
    displayTime = 1500
}) => {
    const [display, updateDisplay] = useState(false)

    useEffect(() => {
        // how about always add a typing bubble?
        setTimeout(() => {
            updateDisplay(true)
        }, displayTime)
    }, [])

    // console.log("images", image)
    // console.log("is typing", typing)
    if (display) {
        return (<Stack
            direction="column"
            justifyContent={"flex-start"}
            sx={{
                width: 1,
                ml: 2,
                mt: 2
            }}
        >
            <React.Fragment>
                <Box
                    sx={{
                        p: 0,
                        m: 0
                    }}
                >
                    <Texts.SmallTip
                        sx={{
                            p: 0,
                            m: 0
                        }}
                    >{moment(time).format('YYYY/MM/DD hh:mm') !== "Invalid date" ? moment(time).format('YYYY/MM/DD hh:mm') : time}</Texts.SmallTip>
                </Box>
                <Stack direction={"row"}>
                    <Box>
                        {image}
                    </Box>
                    <Box
                        sx={{
                            width: 1,
                            // maxWidth: 1,
                            // bgcolor: 'primary.dark',
                            // borderRadius: '0px 16px 16px 16px',
                            p: 2,
                            ml: 1
                        }}
                    >
                        <UrlContentPreview
                            pathObj={message}
                        />
                        {/*<Texts.Paragraph
                            sx={{
                                color: 'primary.contrastText',
                            }}
                        >
                            {message}
                        </Texts.Paragraph>*/}
                    </Box>
                </Stack>
            </React.Fragment>
            <AlwaysScrollToBottom />
        </Stack>)
    }
    return (<Stack
        direction="column"
        justifyContent={"flex-start"}
        sx={{
            width: 1,
            ml: 2,
            mt: 2
        }}
    >
        <Stack direction={"row"}>
            <Box>
                {image}
            </Box>
            <Box
                sx={{
                    maxWidth: .6,
                    bgcolor: 'primary.dark',
                    borderRadius: '0px 16px 16px 16px',
                    p: 2,
                    ml: 1
                }}
            >
                <TypingAnimation fill="#F8F8F8" />
            </Box>
        </Stack>
    </Stack>)
}

const BotBubble = ({
    idx,
    message,
    timestamp,
    time,
    image,
    // typing = false,
    displayTime = 1500,
    hasExtraInfo,
    openModal
}) => {
    const [display, updateDisplay] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)

    useEffect(() => {
        // how about always add a typing bubble?
        setTimeout(() => {
            updateDisplay(true)
        }, displayTime)
    }, [])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined
    // console.log("images", image)
    // console.log("is typing", typing)
    if (display) {
        return (<Stack
            direction="column"
            justifyContent={"flex-start"}
            sx={{
                width: 1,
                ml: 2,
                mt: 2
            }}
        >
            <React.Fragment>
                <Box
                    sx={{
                        p: 0,
                        m: 0
                    }}
                >
                    <Texts.SmallTip
                        sx={{
                            p: 0,
                            m: 0
                        }}
                    >{moment(time).format('YYYY/MM/DD hh:mm') !== "Invalid date" ? moment(time).format('YYYY/MM/DD hh:mm') : time}</Texts.SmallTip>
                </Box>
                <Stack direction={"row"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                    {/*<Box>
                        {image}
                    </Box>*/}
                    <Box
                        sx={{
                            maxWidth: .6,
                            bgcolor: 'primary.dark',
                            borderRadius: '0px 16px 16px 16px',
                            p: 2,
                            ml: 1
                        }}
                    >
                        <Texts.Paragraph
                            sx={{
                                color: 'primary.contrastText',
                            }}
                        >
                            {message}
                        </Texts.Paragraph>
                    </Box>
                    {hasExtraInfo && <React.Fragment>
                    <IconButtons.MoreVert onClick={handleClick} />
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <Buttons.OutlinedButton
                            sx={{
                                borderRadius: 0
                            }}
                            onClick={openModal}
                        >
                            Source論文
                        </Buttons.OutlinedButton>
                    </Popover></React.Fragment>}
                </Stack>
            </React.Fragment>
            <AlwaysScrollToBottom />
        </Stack>)
    }
    return (<Stack
        direction="column"
        justifyContent={"flex-start"}
        sx={{
            width: 1,
            ml: 2,
            mt: 2
        }}
    >
        <Stack direction={"row"}>
            {/*<Box>
                {image}
            </Box>*/}
            <Box
                sx={{
                    maxWidth: .8,
                    bgcolor: 'primary.dark',
                    borderRadius: '0px 16px 16px 16px',
                    p: 2,
                    ml: 1
                }}
            >
                <TypingAnimation fill="#F8F8F8" />
            </Box>
        </Stack>
    </Stack>)
}

const UserBubble = ({
    idx,
    message,
    timestamp,
    time
}) => {
    return (
        <Stack
            direction="column"
            justifyContent={"flex-end"}
            alignItems={"flex-end"}
            sx={{
                width: 1,
                // mr: 2,
                mt: 2
            }}
        >
            <Box
                sx={{
                    p: 0,
                    m: 0
                }}
            >
                <Texts.SmallTip
                    sx={{
                        p: 0,
                        m: 0
                    }}
                >{moment(time).format('YYYY/MM/DD hh:mm') !== "Invalid date" ? moment(time).format('YYYY/MM/DD hh:mm') : time}</Texts.SmallTip>
            </Box>
            <Box
                sx={{
                    maxWidth: .6,
                    bgcolor: 'background.gray',
                    borderRadius: 2,
                    boxShadow: 2,
                    borderRadius: '16px 16px 0px 16px',
                    borderColor: 'primary.light',
                    p: 2
                }}
            >
                <Texts.Paragraph
                    sx={{
                        color: 'primary.main'
                    }}
                >
                    {message}
                </Texts.Paragraph>
            </Box>
        </Stack>)
}

export default ChatWindow